import { motion } from 'framer-motion';
import Navbar       from './components/Navbar';
import Hero         from './components/Hero';
import About        from './components/About';
import Skills       from './components/Skills';
import Experience   from './components/Experience';
import Projects     from './components/Projects';
import Services     from './components/Services';
import Testimonials from './components/Testimonials';
import Contact      from './components/Contact';
import Footer       from './components/Footer';

export default function App() {
  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.45}}
      className="min-h-screen bg-[#07070f] text-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Services />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </motion.div>
  );
}
